<template>
    <div class="container">
        <h1 class="alpha | u-text-color-primary u-text-center">internal-server-error.heading</h1>
        <p class="u-text-center">
            internal-server-error.description
        </p>
    </div>
</template>

<script>
import { pageLoadingStatusMixin } from 'relapp-loading';

export default {
    mixins: [pageLoadingStatusMixin],
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
    }
};
</script>
